import React, { useEffect, useState } from "react";
import "./eventmedia-admin.css"; // toolbar/grid/buttons
import EventMediaForm from "./EventMediaForm";
import EventMediaCard from "./EventMediaCard";

const API = "https://api.ainfotech.com.np";

export default function EventMediaList() {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState("published"); // draft | published | ""
  const [type, setType] = useState("");              // "" | "event" | "media"
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);

  const limit = 12;

  const load = async () => {
    const params = new URLSearchParams({
      ...(status ? { status } : {}),
      ...(type ? { type } : {}),
      page: String(page),
      limit: String(limit),
    });
    const res = await fetch(`${API}/api/eventmedia?${params}`, { credentials: "include" });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.error || "Failed to load");
    setItems(data.items || []);
  };

  useEffect(() => { load().catch(e => alert(e.message)); }, [page, status, type]);

  const onDelete = async (id) => {
    if (!window.confirm("Delete this item?")) return;
    const res = await fetch(`${API}/api/eventmedia/${id}`, { method: "DELETE", credentials: "include" });
    const data = await res.json();
    if (!res.ok) return alert(data?.error || "Delete failed");
    load();
  };

  // Show pager only when needed
  const showPager = page > 1 || (items?.length || 0) === limit;

  return (
    <div className="em-admin">
      <div className="toolbar">
        <h2 className="toolbar__title">Events &amp; Media</h2>

        <div className="toolbar__actions">
          <select className="sel" value={status} onChange={(e) => { setPage(1); setStatus(e.target.value); }}>
            <option value="published">published</option>
            <option value="draft">draft</option>
            <option value="">all</option>
          </select>

          <button className="btn btn--cta" onClick={() => { setEditing(null); setShowForm(true); }}>
            <span className="i i-plus" aria-hidden="true" /> New
          </button>
        </div>
      </div>

      {showForm ? (
        <div className="panel">
          <div className="panel__head">
            <h3 className="panel__title">{editing ? "Edit" : "Create"} Event/Media</h3>
            {/* <button className="btn btn--close" onClick={() => { setShowForm(false); setEditing(null); }}>
              Close
            </button> */}
          </div>

          <EventMediaForm
            initial={editing}
            onSaved={() => { setShowForm(false); setEditing(null); load(); }}
            onCancel={() => { setShowForm(false); setEditing(null); }}
          />
        </div>
      ) : (
        <>
          {items.length === 0 ? (
            <div className="empty">
              <div className="empty__icon">🎬</div>
              <div className="empty__title">No items found</div>
              <div className="empty__desc">Try changing the filter or create a new one.</div>
              <button className="btn btn--cta" onClick={() => { setEditing(null); setShowForm(true); }}>
                <span className="i i-plus" /> Create first item
              </button>
            </div>
          ) : (
            <div className="grid">
              {items.map((it) => (
                <EventMediaCard key={it.id} item={it} onEdit={(row) => { setEditing(row); setShowForm(true); }} onDelete={onDelete} />
              ))}
            </div>
          )}

          {showPager && (
            <div className="pager">
              <button className="pill" disabled={page === 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>
                <span className="i i-left" aria-hidden="true" /> Prev
              </button>
              <span className="badge">Page {page}</span>
              <button className="pill" onClick={() => setPage((p) => p + 1)}>
                Next <span className="i i-right" aria-hidden="true" />
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
